export const addQueryParam = ({ url, key, value }: {
  url: string;
  key: string;
  value?: string | number | boolean;
}): string => {
  const isValidValue = (value !== undefined && value !== null && value !== '');
  if (!isValidValue || !key) {
    return url;
  }
  const param = `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
  return url.includes('?') ? `${url}&${param}` : `${url}?${param}`;
};